"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utilities = require("../utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuTitleWrapper = _styledComponents.default.div.attrs({
  "data-qa": "menu-title-wrapper"
}).withConfig({
  displayName: "DrawerTitle__MenuTitleWrapper",
  componentId: "a2e0i9-0"
})(["background-color:", ";box-shadow:1px 2px 3px 1px rgba(", ",0.1);color:", ";display:flex;min-height:43px;padding:0px 9px;text-align:center;"], function (props) {
  return props.theme.carvana.white.primary;
}, function (props) {
  return (0, _utilities.HexToRgb)(props.theme.carvana.blue.dark);
}, function (props) {
  return props.theme.carvana.gray.dark;
});

var MenuSpace = _styledComponents.default.div.attrs({
  "data-qa": "menu-space"
}).withConfig({
  displayName: "DrawerTitle__MenuSpace",
  componentId: "a2e0i9-1"
})(["flex:1;"]);

var MenuTitle = _styledComponents.default.span.attrs({
  "data-qa": "menu-title"
}).withConfig({
  displayName: "DrawerTitle__MenuTitle",
  componentId: "a2e0i9-2"
})(["align-self:center;flex:1;font-size:12px;font-weight:700;text-transform:uppercase;"]);

var CloseWrapper = _styledComponents.default.div.attrs({
  "data-qa": "close-wrapper"
}).withConfig({
  displayName: "DrawerTitle__CloseWrapper",
  componentId: "a2e0i9-3"
})(["align-items:center;color:", ";fill:", ";cursor:pointer;display:flex;flex:1;justify-content:flex-end;"], function (props) {
  return props.theme.carvana.blue.primary;
}, function (props) {
  return props.theme.carvana.blue.primary;
});

var SvgWrapper = _styledComponents.default.div.attrs({
  "data-qa": "svg-wrapper"
}).withConfig({
  displayName: "DrawerTitle__SvgWrapper",
  componentId: "a2e0i9-4"
})(["display:block;width:14px;height:14px;margin:-7px 4px 0 0;svg{width:100%;height:100%;}"]);

var _ref2 = _react.default.createElement(MenuSpace, null);

var _ref3 = _react.default.createElement(SvgWrapper, null, _react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, _react.default.createElement("g", {
  id: "close-x-13x13-dark"
}, _react.default.createElement("path", {
  d: "M7.58,6.5l5.2-5.19a.79.79,0,0,0,0-1.09.79.79,0,0,0-1.09,0L6.5,5.42,1.31.22A.79.79,0,0,0,.22.22a.79.79,0,0,0,0,1.09L5.42,6.5.22,11.69a.79.79,0,0,0,0,1.09A.77.77,0,0,0,.77,13a.76.76,0,0,0,.54-.22L6.5,7.58l5.19,5.2a.79.79,0,0,0,1.09,0,.79.79,0,0,0,0-1.09Z"
}))));

var DrawerTitle = function DrawerTitle(_ref) {
  var className = _ref.className,
      close = _ref.close,
      title = _ref.title;
  return _react.default.createElement(MenuTitleWrapper, {
    className: className,
    "data-qa": "drawer-title"
  }, _ref2, _react.default.createElement(MenuTitle, null, title), _react.default.createElement(CloseWrapper, {
    onClick: close
  }, _ref3));
};

DrawerTitle.defaultProps = {
  className: ''
};
var _default = DrawerTitle;
exports.default = _default;
module.exports = exports.default;